<template>
    <PremiumAd
        :text="t('premium_ad.text')"
        :btn-text="t('button.go_premium')"
        tracking-category="home_dashboard"
        impression-tracking-name="home_premium_button_impression"
        click-tracking-name="home_premium_button_click"
        @premium-ad-clicked="premiumAdClicked"
    />
</template>

<script lang="ts">
import PremiumAd from '@/components/PremiumAd';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'DashboardWidgetPremium',
    components: { PremiumAd },
    setup() {
        const { t } = useTranslation('subscription');
        return { t };
    },
    methods: {
        async premiumAdClicked() {
            sessionStorage.setItem('subscriptionProcessOriginUrl', window.location.href);
            window.location.href = route('subscription.shop.show');
        },
    },
};
</script>
